import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import { Autoplay, Pagination, EffectFade } from "swiper/modules";
import  { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import "bootstrap-icons/font/bootstrap-icons.css";


const AboutUs = () => {
  return (
    <div className="page-wrapper">
      {/* Header Section */}
       <header className="site-header header-style-1">
        <div className="pbmit-title-bar-wrapper">
          <div className="container">
            <div className="pbmit-title-bar-content">
              <div className="pbmit-title-bar-content-inner">
                <div className="pbmit-tbar">
                  <div className="pbmit-tbar-inner container">
                    <h1 className="pbmit-tbar-title">About Us</h1>
                  </div>
                </div>
                <div className="pbmit-breadcrumb">
                  <div className="pbmit-breadcrumb-inner">
                    <span>
                      <a title="" href="#" className="home">
                        <span> TRACKLINE XR</span>
                      </a>
                    </span>
                    <span className="sep">
                      <i className="pbmit-base-icon-angle-right"></i>
                    </span>
                    <span>
                      <span className="post-root post post-post current-item">
                        About Us
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Title Bar End*/}
      </header>

      {/* Intro Section */}
      <section className="py-5 bg-light">
  <div className="container">
    <div className="row align-items-center">
      
      {/* Left Image as Circle */}
      <div className="col-md-5 mb-4 mb-md-0 text-center">
        <div className="position-relative d-inline-block">
          <img
            src={`${process.env.PUBLIC_URL}/assets/images/homepage-3/about-01.jpg`}
            className="img-fluid rounded-circle shadow-lg border border-4 border-white"
            alt="About Trackline XR"
            style={{ width: "280px", height: "280px", objectFit: "cover" }}
          />
          {/* Decorative Ring */}
          <div className="position-absolute top-50 start-50 translate-middle rounded-circle border border-3 border-primary" 
               style={{ width: "320px", height: "320px" }}>
          </div>
        </div>
      </div>

      {/* Right Content */}
      <div className="col-md-7">
        <span className="badge bg-primary-subtle text-primary px-3 py-2 rounded-pill mb-3">
         <h2> About Us </h2>
        </span>
        <h4 className="fw-bold mb-3 lh-sm">
          We’re <span className="text-primary">Transforming</span> Freight
        </h4>
        <p className="lead text-muted mb-4">
          At <strong>Trackline XR</strong>, we simplify freight by turning a 
          complex, fragmented process into a seamless logistics ecosystem.  
          We don’t just move loads — we move logistics forward with  
          <span className="text-primary fw-semibold"> trust</span>,  
          <span className="text-success fw-semibold"> compliance</span>, and  
          <span className="text-warning fw-semibold"> sustainability</span>.
        </p>
        
      </div>
    </div>
  </div>
</section>

      {/* Mission Section */}
      <section className="py-5">
        <div className="container">
          <div className="text-center mb-5">
            <h2> Our Mission</h2>
            <p className="lead">
              Our mission is simple: to give shippers, carriers, and partners the clarity,
              reliability, and control they need to operate smarter and faster.
            </p>
          </div>
          <div className="row g-4">
            <div className="col-md-6 col-lg-4">
              <div className="card h-100 shadow-sm border-0">
                <div className="card-body text-center">
                  <i className="bi bi-speedometer2 display-4 text-primary mb-3"></i>
                  <h5 className="card-title">Smart Freight Operations</h5>
                  <p className="card-text">
                    Expertise in drayage, intermodal, trucking, warehousing, and distribution — all
                    coordinated through one streamlined platform.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="card h-100 shadow-sm border-0">
                <div className="card-body text-center">
                  <i className="bi bi-eye display-4 text-success mb-3"></i>
                  <h5 className="card-title">End-to-End Visibility</h5>
                  <p className="card-text">
                    From port and rail operations to over-the-road and last-mile delivery, we provide
                    full transparency and live updates, 24/7.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="card h-100 shadow-sm border-0">
                <div className="card-body text-center">
                  <i className="bi bi-shield-check display-4 text-warning mb-3"></i>
                  <h5 className="card-title">Trusted Carrier Network</h5>
                  <p className="card-text">
                    Every carrier we work with is vetted, insured, and compliant with FMCSA standards.
                    Our safeguards protect against fraud, double brokerage, and service risks.
                  </p>
                </div>
              </div>
            </div>
            
          </div>
          <div className="row g-4 mt-4 justify-content-center">
            <div className="col-md-6 col-lg-4">
              <div className="card h-100 shadow-sm border-0">
                <div className="card-body text-center">
                  <i className="bi bi-leaf display-4 text-info mb-3"></i>
                  <h5 className="card-title">Sustainability First</h5>
                  <p className="card-text">
                    We integrate carbon tracking, EV-readiness, and green freight practices into
                    everyday operations, helping customers move goods responsibly.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="card h-100 shadow-sm border-0">
                <div className="card-body text-center">
                  <i className="bi bi-people display-4 text-danger mb-3"></i>
                  <h5 className="card-title">CSR Commitment</h5>
                  <p className="card-text">
                    We reinvest in community growth, clean energy adoption, and workforce development,
                    ensuring that progress in freight also uplifts people and protects the planet.
                  </p>
                </div>
              </div>
            </div>
            </div>
        </div>
      </section>

      {/* Why Trackline XR */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <h2> Why Trackline XR</h2>
            <p className="lead">
              Most brokers and systems handle transactions. We deliver trust, visibility, and
              long-term partnerships.
            </p>
          </div>
          <div className="row text-center g-4">
            <div className="col-md-4">
              <div className="card h-100 shadow-sm border-0 p-4">
                <i className="bi bi-geo-alt display-4 text-primary mb-3"></i>
                <h5 className="card-title">Major U.S. Ports & Rail Yards</h5>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card h-100 shadow-sm border-0 p-4">
                <i className="bi bi-arrow-right-circle display-4 text-success mb-3"></i>
                <h5 className="card-title">Cross-Border Trade with Canada</h5>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card h-100 shadow-sm border-0 p-4">
                <i className="bi bi-truck display-4 text-warning mb-3"></i>
                <h5 className="card-title">Nationwide Truckload & LTL Coverage</h5>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Closing Section */}
      <section className="py-5 text-center">
        <div className="container">
          <h2> Building the Future of Logistics</h2>
          <p className="lead mb-4">
            The future of logistics is connected, transparent, and sustainable. At Trackline XR,
            we are proud to build that future every day — one shipment, one partnership, one
            innovation at a time.
          </p>
          <h4 className="text-primary">Trackline XR — Where Logistics Meets Intelligence</h4>
        </div>
      </section>

     <section>
       <div className="container">
         <div className="testimonial-one">
           <div className="row g-0">
             {/* Left Icon Section */}
             <div className="col-md-12 col-xl-3">
               <div className="pbmit-spinner-box-style-1">
                 <div className="pbmit-ihbox-box">
                   <div className="pbmit-ihbox-icon">
                     <div className="pbmit-ihbox-icon-wrapper pbmit-icon-type-icon">
                       {/* Icon SVG */}
                       <svg
                         id="Layer_1"
                         enableBackground="new 0 0 100 100"
                         viewBox="0 0 100 100"
                         xmlns="http://www.w3.org/2000/svg"
                       >
                         <path d="m54.75 61.73v-2.37c0-21.98 16.27-39.89 37.52-42.44 2.79-.34 5.23 1.92 5.23 4.73 0 2.43-1.83 4.42-4.24 4.72-7.49.94-14.19 4.34-19.2 9.27-1.78 1.75-.5 4.73 1.99 4.72 12.25 0 21.97 10.1 21.35 22.48-.54 10.83-9.41 19.7-20.24 20.24-12.38.62-22.48-9.1-22.48-21.35z"></path>
                         <path d="m2.5 61.26v-1.9c0-21.98 16.27-39.89 37.52-42.44 2.79-.34 5.23 1.92 5.23 4.73 0 2.43-1.83 4.42-4.24 4.72-7.48.94-14.19 4.34-19.2 9.27-1.78 1.75-.5 4.73 2 4.72 11.87 0 21.37 9.5 21.37 21.37 0 12.09-9.84 21.71-22 21.37-11.64-.33-20.75-10.2-20.75-21.84z"></path>
                       </svg>
                     </div>
                   </div>
                   {/* Circle Text */}
                   <svg viewBox="0 0 200 200">
                     <defs>
                       <path
                         d="M0, 100a100, 100 0 1, 0 200, 0a100, 100 0 1, 0 -200, 0"
                         id="txt-path"
                       ></path>
                     </defs>
                     <circle cx="160" cy="100" r="80" fill="none"></circle>
                     <text>
                       <textPath startOffset="0" xlinkHref="#txt-path">
                         Testimonial - trusted by clients -
                       </textPath>
                     </text>
                   </svg>
                 </div>
               </div>
             </div>
     
             {/* Right Testimonials Section */}
             <div className="col-md-12 col-xl-9">
               <Swiper
                 modules={[Autoplay, Pagination]}
                 autoplay={{ delay: 10000, disableOnInteraction: false }}
                 loop={true}
                 pagination={{ clickable: true }}
                 slidesPerView={1}
                 className="swiper-slider mt-xl-0 mt-5"
               >
                 {/* Slide 1 */}
                 <SwiperSlide>
                   <article className="pbmit-testimonial-style-1">
                     <div className="pbminfotech-post-item">
                       <div className="pbmit-box-content-wrap">
                         <div className="pbminfotech-box-star-ratings">
                           <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                           <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                           <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                           <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                           <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                         </div>
                         <div className="pbminfotech-box-desc">
                           <blockquote className="pbminfotech-testimonial-text">
                             <p>
                               “Trackline XR has transformed how we manage freight. From port drayage at LA/LB to final-mile delivery, their team provides updates 24/7 and ensures zero surprises. We’ve seen cost savings and smoother operations since partnering.”
                             </p>
                           </blockquote>
                         </div>
                         <div className="pbminfotech-box-author d-flex align-items-center px-4">
                           <div className="pbminfotech-box-img">
                             <div className="pbmit-featured-img-wrapper">
                               <div className="pbmit-featured-wrapper">
                                 <img
                                   src={`${process.env.PUBLIC_URL}/assets/images/homepage-1/reviewer/reviewer-05.png`}
                                   alt="reviewer-01"
                                 />
                               </div>
                             </div>
                           </div>
                           <div className="pbmit-auther-content">
                             <h3 className="pbminfotech-box-title">
                               Supply Chain Director
                             </h3>
                             <div className="pbminfotech-testimonial-detail">
                               National Retailer
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                   </article>
                 </SwiperSlide>
     
                 {/* Slide 2 */}
                 <SwiperSlide>
                   <article className="pbmit-testimonial-style-1">
                     <div className="pbminfotech-post-item">
                       <div className="pbmit-box-content-wrap">
                         <div className="pbminfotech-box-star-ratings">
                           <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                           <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                           <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                           <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                           <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                         </div>
                         <div className="pbminfotech-box-desc">
                           <blockquote className="pbminfotech-testimonial-text">
                             <p>
                               “Working with Trackline XR feels like working with a true partner. Their dispatch team is professional, payments are always on time, and their quick-pay program keeps our cash flow healthy. It’s the kind of relationship every carrier hopes for.”
                             </p>
                           </blockquote>
                         </div>
                         <div className="pbminfotech-box-author d-flex align-items-center px-4">
                           <div className="pbminfotech-box-img">
                             <div className="pbmit-featured-img-wrapper">
                               <div className="pbmit-featured-wrapper">
                                 <img
                                   src={`${process.env.PUBLIC_URL}/assets/images/homepage-1/reviewer/reviewer-07.png`}
                                   alt="reviewer-02"
                                 />
                               </div>
                             </div>
                           </div>
                           <div className="pbmit-auther-content">
                             <h3 className="pbminfotech-box-title">
                               Owner-Operator
                             </h3>
                             <div className="pbminfotech-testimonial-detail">
                               Midwest Carrier
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                   </article>
                 </SwiperSlide>
     
                 {/* Slide 3 */}
                 <SwiperSlide>
                   <article className="pbmit-testimonial-style-1">
                     <div className="pbminfotech-post-item">
                       <div className="pbmit-box-content-wrap">
                         <div className="pbminfotech-box-star-ratings">
                           <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                           <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                           <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                           <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                           <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                         </div>
                         <div className="pbminfotech-box-desc">
                           <blockquote className="pbminfotech-testimonial-text">
                             <p>
                               “Reliability and compliance are critical for us, and Trackline XR has delivered both without fail. Their vetted carrier network and transparent operations give us complete confidence in every shipment, whether it’s a single load or a high-volume lane.”
                             </p>
                           </blockquote>
                         </div>
                         <div className="pbminfotech-box-author d-flex align-items-center px-4">
                           <div className="pbminfotech-box-img">
                             <div className="pbmit-featured-img-wrapper">
                               <div className="pbmit-featured-wrapper">
                                 <img
                                   src={`${process.env.PUBLIC_URL}/assets/images/homepage-1/reviewer/reviewer-08.png`}
                                   alt="reviewer-03"
                                 />
                               </div>
                             </div>
                           </div>
                           <div className="pbmit-auther-content">
                             <h3 className="pbminfotech-box-title">
                               Logistics Manager
                             </h3>
                             <div className="pbminfotech-testimonial-detail">
                               Industrial Manufacturer
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                   </article>
                 </SwiperSlide>
     
                 {/* Slide 4 */}
                 <SwiperSlide>
                   <article className="pbmit-testimonial-style-1">
                     <div className="pbminfotech-post-item">
                       <div className="pbmit-box-content-wrap">
                         <div className="pbminfotech-box-star-ratings">
                           <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                           <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                           <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                           <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                           <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                         </div>
                         <div className="pbminfotech-box-desc">
                           <blockquote className="pbminfotech-testimonial-text">
                             <p>
                               “Navigating U.S. ports and customs used to be complicated. Trackline XR simplified the entire process, from customs clearance to inland transport, with clear communication at every step. They’ve become our go-to partner for U.S. logistics.”
                             </p>
                           </blockquote>
                         </div>
                         <div className="pbminfotech-box-author d-flex align-items-center px-4">
                           <div className="pbminfotech-box-img">
                             <div className="pbmit-featured-img-wrapper">
                               <div className="pbmit-featured-wrapper">
                                 <img
                                   src={`${process.env.PUBLIC_URL}/assets/images/homepage-1/reviewer/reviewer-09.png`}
                                   alt="reviewer-04"
                                 />
                               </div>
                             </div>
                           </div>
                           <div className="pbmit-auther-content">
                             <h3 className="pbminfotech-box-title">
                               Export Manager
                             </h3>
                             <div className="pbminfotech-testimonial-detail">
                               Global Trading Company
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                   </article>
                 </SwiperSlide>
     
                 {/* Slide 5 */}
                 <SwiperSlide>
                   <article className="pbmit-testimonial-style-1">
                     <div className="pbminfotech-post-item">
                       <div className="pbmit-box-content-wrap">
                         <div className="pbminfotech-box-star-ratings">
                           <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                           <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                           <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                           <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                           <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                         </div>
                         <div className="pbminfotech-box-desc">
                           <blockquote className="pbminfotech-testimonial-text">
                             <p>
                               “Trackline XR’s ability to integrate warehousing and trucking seamlessly has eliminated bottlenecks in our operations. Their visibility tools and proactive communication set them apart from traditional brokers.”
                             </p>
                           </blockquote>
                         </div>
                         <div className="pbminfotech-box-author d-flex align-items-center px-4">
                           <div className="pbminfotech-box-img">
                             <div className="pbmit-featured-img-wrapper">
                               <div className="pbmit-featured-wrapper">
                                 <img
                                   src={`${process.env.PUBLIC_URL}/assets/images/homepage-1/reviewer/reviewer-10.png`}
                                   alt="reviewer-05"
                                 />
                               </div>
                             </div>
                           </div>
                           <div className="pbmit-auther-content">
                             <h3 className="pbminfotech-box-title">
                               Operations Head
                             </h3>
                             <div className="pbminfotech-testimonial-detail">
                               3PL Partner
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                   </article>
                 </SwiperSlide>
     
               </Swiper>
             </div>
           </div>
         </div>
       </div>
     </section>
    </div>
  );
};

export default AboutUs;
